import { reactive, ref, watchEffect } from 'vue'

import roles from './roles'

export { roles }

function parse() {
    const raw = decodeURIComponent(/(?<=(^|(;\s+))auth=)[^;]+/.exec(document.cookie)?.[0] ?? '')
    const parts = raw.split('.')

    if (parts.length === 1) {
        return {}
    }

    return JSON.parse(atob(parts[1]))
}

const parsed = ref(parse())
export const jwt = reactive({})

watchEffect(() => {
    Object.assign(jwt, {
        authenticated: !!parsed.value.sub,
        id: parsed.value.id,
        organizationId: parsed.value.oid,
        organizationName: parsed.value.on,
        username: parsed.value.sub,
        firstName: parsed.value.fn,
        lastName: parsed.value.ln,
        name: `${parsed.value.fn} ${parsed.value.ln}`,
        roles: parsed.value.role || [],
    })
})

export function hasRole(role) {
    return parsed.value.role?.indexOf(role) > -1
}
export function hasAdminRole() {
    return hasRole(roles.admin)
}
export function hasAiAdminRole() {
    return hasRole(roles.aiAdmin) || hasAdminRole()
}
export function hasDataEntryRole() {
    return hasInHouseDataEntryRole() || hasRole(roles.dataEntry)
}
export function hasInHouseDataEntryRole() {
    return hasRole(roles.inHouseDataEntry)
}
export function hasInternalReadRole() {
    return hasRole(roles.internalRead)
}
export function hasInterviewersRole() {
    return hasRole(roles.interviewers)
}
export function hasManageOrganizationRole() {
    return hasRole(roles.manageOrganization)
}
export function hasMatchingRole() {
    return hasRole(roles.matching)
}
export function hasSalesAdminRole() {
    return hasRole(roles.salesAdmin)
}
export function hasResearchRole() {
    return hasRole(roles.research)
}
export function hasReadRole() {
    return hasRole(roles.read)
}
export function hasAnyEditRole() {
    return [
        roles.admin,
        roles.aiAdmin,
        roles.dataEntry,
        roles.matching,
        roles.inHouseDataEntry,
        roles.research,
        roles.dataEntryJobHistory,
        roles.dataEntryInterviewSurveys,
    ].some(hasRole)
}

export function refresh() {
    parsed.value = parse()
}
